export default __webpack_public_path__ + "static/Group-1252-def0bead60f50307c941d0878dd5b818.png";